module.exports = __webpack_public_path__ + "static/assets/9db9c5c729dfd9717ce5d0dcea026f96.gif";